import Modal from "react-modal";
import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import { BloqueioDescriptionText, BloqueioInfoLink } from "./style";
import Product from "types/Product";

interface BloqueioIndicatorProps {
  product: Product;
  modalBloqueioIsOpen: boolean;
  closeModalBloqueio: () => void;
  openModalBloqueio: () => void;
}

function BloqueioIndicator({
  product,
  modalBloqueioIsOpen,
  closeModalBloqueio,
  openModalBloqueio,
}: BloqueioIndicatorProps) {
  if (!product.bloqueio) {
    return null;
  }

  return (
    <>
      {modalBloqueioIsOpen && (
        <Modal
          isOpen={modalBloqueioIsOpen}
          className="modal"
          onRequestClose={closeModalBloqueio}
          contentLabel="Informações de Bloqueio do Produto"
          style={{ overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
        >
          <div className="head">
            <h2>Produto com bloqueio</h2>
            <IconButton onClick={closeModalBloqueio} type="button">
              <ClearIcon />
            </IconButton>
          </div>
          <div className="content">
            <div>
              <BloqueioDescriptionText>
                Venda limitada a quantidade máxima de{" "}
                {product.bloqueio.qt_limita_venda} produtos.
              </BloqueioDescriptionText>
              <BloqueioDescriptionText>
                {product.bloqueio.qt_disponivel < 0
                  ? "Limite atingido"
                  : `Quantidade disponível: ${product.bloqueio.qt_disponivel} ${
                      product.bloqueio.qt_disponivel > 1
                        ? "produtos"
                        : "produto"
                    }.`}
              </BloqueioDescriptionText>
            </div>
            <div>
              <button onClick={closeModalBloqueio} type="button">
                Ok
              </button>
            </div>
          </div>
        </Modal>
      )}
      <em>
        (
        <BloqueioInfoLink onClick={openModalBloqueio}>
          {product.bloqueio.qt_disponivel < 0
            ? "Limite atingido"
            : `Quantidade disponível: ${product.bloqueio.qt_disponivel}`}
        </BloqueioInfoLink>
        )
      </em>
    </>
  );
}

export default BloqueioIndicator;
